export default __webpack_public_path__ + "static/media/a4.996650c9.png";